<template>
  <div class="market-winner-v2">
    <div class="market-winner-v2__title">Winner</div>
    <div class="market-winner-v2__icon"></div>
  </div>
</template>

<script src="./market-winner-v2.js"></script>
<style src="./market-winner-v2.scss" lang="scss"></style>
